import React from 'react';
import styled from 'styled-components';
import { Colors } from '../../../ui';
import { AccountBlock } from './AccountBlock';
import { AdminMenu } from './AdminMenu';
import { AdvertBlock } from './AdvertBlock';
import { Navigation } from './Navigation';

const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 0 0 auto;
    padding: 0 1.5rem;    
    border-bottom: solid 1px ${Colors.borderLight};
`;

const Main = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;    
`;

const Footer = styled.div`
    flex: 0 0 auto;
    border-top: solid 1px ${Colors.borderLight};
`;

export const AdminNavigationView = () => {
    // NavigationScope is at a higher level (near AppScope).  It should be here, but it will reload each page change at the moment and I
    // don't have the time to figure out how to stop that.
    // return <Flexer grow flex="column">
    //     <Header>
    //         <a href="/">
    //             <Canton />
    //         </a>
    //         <PlanBadge />
    //     </Header>
    //     <Main>
    // <AdminMenu />
    // <AdvertBlock />
    //     </Main>
    //     <Footer>
    //         <AccountBlock />
    //     </Footer>
    // </Flexer>;

    return <Navigation>
        <Navigation.Section>
            <AccountBlock />
        </Navigation.Section>
        <Navigation.Divide />
        <Navigation.Section grow>
            <AdminMenu />
        </Navigation.Section>
        <Navigation.Advert>
            <AdvertBlock />
        </Navigation.Advert>
        <Navigation.Divide />
    </Navigation>;
};
